/**
 * Latinología Native Popups (Vanilla JS)
 * Handles body mounting, focus trap, accessibility and smooth overlays.
 */
(() => {
  let activeModal = null;
  let previouslyFocusedElement = null;
  let listenersAttached = false;

  function initPopups() {
    if (listenersAttached) return;
    listenersAttached = true;

    // 1. Event Delegation for Triggers
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-lat-popup-trigger]');
      if (trigger) {
        e.preventDefault();
        const popupId = trigger.getAttribute('data-lat-popup-trigger');
        if (popupId) {
          openModal(popupId.trim());
        }
      }
    });

    // 2. Global Close Listeners (Overlay click, X button)
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('lat-popup-overlay')) {
        closeModal();
      } else if (e.target.closest('.lat-popup-close')) {
        closeModal();
      }
    });

    // 3. Escape Key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && activeModal) {
        closeModal();
      }
    });

    // 4. Focus Trap Logic
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab' || !activeModal) return;

      const focusableElements = activeModal.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      
      if (focusableElements.length === 0) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (e.shiftKey) { // Shift + Tab
        if (document.activeElement === firstElement) {
          lastElement.focus();
          e.preventDefault();
        }
      } else { // Tab
        if (document.activeElement === lastElement) {
          firstElement.focus();
          e.preventDefault();
        }
      }
    });
  }

  // Open Modal
  function openModal(id) {
    const modalOverlay = document.getElementById(`lat-popup-${id}`);
    if (!modalOverlay) {
      console.warn('[Latinología] Modal no encontrado para ID:', id);
      return;
    }

    // Move modal directly to document.body to escape any section stacking contexts and sticky header
    if (modalOverlay.parentElement !== document.body) {
      document.body.appendChild(modalOverlay);
    }

    previouslyFocusedElement = document.activeElement;
    activeModal = modalOverlay;

    // Body scroll lock
    document.body.style.overflow = 'hidden';

    // Show modal
    modalOverlay.classList.add('is-active');
    modalOverlay.setAttribute('aria-hidden', 'false');

    // Track GA4
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'popup_open',
        popup_name: id
      });
    }

    // Focus close button
    setTimeout(() => {
      const closeBtn = modalOverlay.querySelector('.lat-popup-close');
      if (closeBtn) closeBtn.focus();
    }, 100);
  }

  // Close Modal
  function closeModal() {
    if (!activeModal) return;

    activeModal.classList.remove('is-active');
    activeModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    
    if (previouslyFocusedElement) {
      previouslyFocusedElement.focus();
    }
    
    activeModal = null;
  }

  // Expose API globally
  window.LatPopups = {
    open: openModal,
    close: closeModal
  };

  // Run immediately or on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPopups);
  } else {
    initPopups();
  }

  // Support Shopify Theme Editor dynamic reloads
  document.addEventListener('shopify:section:load', () => {
    initPopups();
  });
})();
